/* ============================================================
   Anti-collision demo driver.
   Paired with sections/anti-collision.liquid + section-anti-collision.css.

   Animates a desk lowering toward an obstacle: the FEET stay fixed on the floor,
   the legs telescope (--ac-leg-h shrinks) so the tabletop descends, it STOPS on
   contact, then retreats ~5 cm — with an eased motion and a live cm readout in
   the corner. rAF time-based, IntersectionObserver-gated, prefers-reduced-motion
   aware (freezes on the "stopped on contact" frame).
   ============================================================ */
(function () {
  // Geometry (px) + cm mapping. cm = 60 + (legH - 30) / 2  →  150px=120cm, 54px=72cm.
  var LEG_MAX = 150;     // desk raised
  var LEG_CONTACT = 54;  // tabletop meets the obstacle (== obstacle height in CSS)
  var LEG_RETREAT = 64;  // backs off ~10px ≈ 5 cm after the collision

  // Phase durations (ms)
  var D = 2200;   // descend
  var HL = 300;   // hold on contact
  var R = 520;    // retreat
  var HH = 760;   // hold raised-a-little
  var RS = 1050;  // reset back to top
  var TOTAL = D + HL + R + HH + RS;

  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function cmFor(legH) { return Math.round(60 + (legH - 30) / 2); }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(scene) {
    if (scene.dataset.acReady) return;
    scene.dataset.acReady = '1';

    var readout = scene.querySelector('[data-ac-readout]');
    var alert = scene.querySelector('[data-ac-alert]');

    function render(legH, alertOn) {
      scene.style.setProperty('--ac-leg-h', legH.toFixed(1) + 'px');
      if (readout) readout.textContent = cmFor(legH);
      if (alert) alert.classList.toggle('is-on', !!alertOn);
    }

    // Reduced motion: park it on the stopped-on-contact frame, no loop.
    if (REDUCE) {
      render(LEG_CONTACT, true);
      return;
    }

    var start = null;
    var rafId = null;
    var running = false;

    function frame(now) {
      if (start === null) start = now;
      var e = (now - start) % TOTAL;
      var legH;
      var alertOn = false;

      if (e < D) {
        legH = LEG_MAX + (LEG_CONTACT - LEG_MAX) * easeInOut(e / D);
      } else if (e < D + HL) {
        legH = LEG_CONTACT;
        alertOn = true;
      } else if (e < D + HL + R) {
        var t = (e - D - HL) / R;
        legH = LEG_CONTACT + (LEG_RETREAT - LEG_CONTACT) * easeOut(t);
        alertOn = t < 0.55;
      } else if (e < D + HL + R + HH) {
        legH = LEG_RETREAT;
      } else {
        var t2 = (e - D - HL - R - HH) / RS;
        legH = LEG_RETREAT + (LEG_MAX - LEG_RETREAT) * easeInOut(t2);
      }

      render(legH, alertOn);
      rafId = requestAnimationFrame(frame);
    }

    function play() {
      if (running) return;
      running = true;
      start = null;
      rafId = requestAnimationFrame(frame);
    }
    function pause() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    render(LEG_MAX, false); // initial raised state

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) { en.isIntersecting ? play() : pause(); });
        },
        { threshold: 0.25 }
      );
      io.observe(scene);
    } else {
      play();
    }
  }

  function scan() {
    document.querySelectorAll('[data-anti-collision]').forEach(setup);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
